import React from "react";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";

export default function ToggleButton({
  checked,
  onChange,
  backgroundColorTrack,
  backgroundColorThumb,
  size = "small",
}) {

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      size= {size}
      sx={{
        "& .MuiSwitch-track": {
          backgroundColor: `${backgroundColorTrack} !important`, // Custom track color
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: backgroundColorThumb, // Custom thumb color
        },
      }}
    />
  );
}
